<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100 p-6">
    <div class="bg-white shadow-lg rounded-lg p-6 w-full max-w-lg">
      <!-- Logo Section -->
      <div class="flex justify-center mb-6">
        <img src="@/assets/logo.jpg" alt="Logo" class="h-20" />
      </div>

      <h1 class="text-2xl font-semibold text-center mb-6">Checklist</h1>
      
      <!-- Search Form -->
      <div class="space-y-4">
        <div>
          <label for="searchQuery" class="block text-gray-700 mb-4 font-medium">Ingrese el número de Checklist:</label>
          <input 
            type="text" 
            id="searchQuery" 
            v-model="searchQuery" 
            placeholder="Número de Checklist"
            class="w-full border border-gray-300 rounded-md p-2 focus:ring focus:ring-blue-300"
          />
        </div>
        <button 
          @click="searchFiles"
          :disabled="isSearching"
          class="w-full bg-blue-500 text-white font-semibold p-2 rounded-md hover:bg-blue-600 transition duration-200 flex items-center justify-center"
        >
          <svg 
            v-if="isSearching" 
            class="animate-spin h-5 w-5 mr-3" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24"
          >
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Buscar
        </button>
      </div>

      <!-- Results Section -->
      <div v-if="results.length > 0" class="mt-6">
        <h2 class="text-xl font-semibold">Archivos Encontrados:</h2>
        <ul class="space-y-4 mt-4">
          <li 
            v-for="file in results" 
            :key="file.Id" 
            class="flex justify-between items-center p-4 border rounded-md border-gray-300 bg-gray-50 hover:bg-gray-100 transition duration-200"
          >
            <span class="text-gray-700">{{ file.Numero }}</span>
            <button 
              @click="downloadFile(file)"
              class="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 transition duration-200"
            >
              Descargar
            </button>
          </li>
        </ul>
      </div>

      <!-- No Results or Error Message -->
      <div 
        v-if="(searched && results.length === 0) || message"
        class="mt-4 text-center"
      >
        <p 
          :class="[
            'p-4 rounded-lg font-semibold transition-all duration-300',
            results.length === 0 
              ? 'bg-red-100 text-red-800 border-2 border-red-300 animate-pulse' 
              : 'bg-red-100 text-red-800'
          ]"
        >
          {{ message || 'No se encontraron archivos' }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FileViewer',
  data() {
    return {
      searchQuery: '',
      results: [],
      message: '',
      searched: false,
      isSearching: false
    };
  },
  methods: {
    async searchFiles() {
  this.results = [];
  this.searched = false;
  this.message = '';
  this.isSearching = true;

  if (!this.searchQuery) {
    this.message = 'Por favor, ingrese un número de Checklist';
    this.isSearching = false;
    return;
  }
  
  try {
    const response = await axios.post('/api-proxy', {
      table: 'mc9g7j0wqo9xu30',
      where: `(Numero,eq,${this.searchQuery})`
    });

    this.results = response.data.list || [];
    this.searched = true;
    
    if (this.results.length === 0) {
      this.message = 'No se encontraron archivos';
    }
  } catch (error) {
    console.error('Search error:', error);
    this.message = 'Error al buscar archivos';
  } finally {
    this.isSearching = false;
  }
},
    async downloadFile(file) {
      try {
        // Check if PDF exists
        if (!file.PDF || file.PDF.length === 0) {
          this.message = 'No hay archivo PDF disponible';
          return;
        }

        // Log the file object to inspect its structure
        console.log('PDF file object:', file.PDF[0]);
        
        // Get the file URL from the attachment
        const fileData = file.PDF[0];
        
        if (!fileData.url && !fileData.path) {
          this.message = 'URL del archivo no disponible';
          return;
        }
        
        // Use url if available, otherwise fall back to path
        const fileUrl = `https://database.trhon.com/${fileData.path}`;
        
        // Open the file in a new tab
        window.open(fileUrl, '_blank');
        
        // Alternatively, for direct download without using blob:
        // const link = document.createElement('a');
        // link.href = fileUrl;
        // link.setAttribute('download', fileData.title || `Checklist_${file.Numero}.pdf`);
        // link.setAttribute('target', '_blank');  // Optional: open in new tab
        // document.body.appendChild(link);
        // link.click();
        // link.remove();
      } catch (error) {
        console.error('Download error:', error);
        this.message = 'Error al descargar el archivo';
        
        if (error.response) {
          console.error('Error response:', error.response.status, error.response.data);
        }
      }
    }
  }
};
</script>

<style scoped>
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>